import React, { useState } from 'react';
import { BrowserRouter as Router, Route, Routes, Link, useLocation } from 'react-router-dom';
import CodingProjects from './pages/CodingProjects';
import ArtProjects from './pages/ArtProjects';
import DesignProjects from './pages/DesignProjects';
import Animation from './pages/Animation';
import InteractivePage from './pages/Interactive';
import HomePage from './pages/HomePage';
import './App.css';

function Header() {
  const location = useLocation();
  const isHomePage = location.pathname === "/";
  const isInteractivePage = location.pathname === "/interactive";

  const [isNavOpen, setIsNavOpen] = useState(false); // State for toggling the menu

  if (isHomePage) return null; // Hide header on the homepage

  const toggleNav = () => setIsNavOpen(prev => !prev); // Toggle the navigation menu

  return (
    <header className={`app-header ${isInteractivePage ? 'interactive-header' : ''}`}>
      <Link to="/" className={`home-link ${isInteractivePage ? 'interactive-home-link' : ''}`}>
        will hardison
      </Link>
      <button className="menu-toggle" onClick={toggleNav}>
        ☰
      </button>
      <nav className={`projects-nav ${isNavOpen ? "open" : ""} ${isInteractivePage ? 'interactive-nav' : ''}`}>
        <Link className={`projects-nav-link ${isInteractivePage ? 'interactive-header-link' : ''}`} to="/code">code</Link>
        <Link className={`projects-nav-link ${isInteractivePage ? 'interactive-header-link' : ''}`} to="/art">art</Link>
        <Link className={`projects-nav-link ${isInteractivePage ? 'interactive-header-link' : ''}`} to="/design">design</Link>
        <Link className={`projects-nav-link ${isInteractivePage ? 'interactive-header-link' : ''}`} to="/animation">animation</Link>
        <Link className={`projects-nav-link interactive-header-link ${isInteractivePage ? 'interactive-header-link' : ''}`} to="/interactive">interactive</Link>
      </nav>
    </header>
  );
}

function App() {
  return (
    <Router>
      <div className="app-container">
        <Header />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/code" element={<CodingProjects />} />
          <Route path="/art" element={<ArtProjects />} />
          <Route path="/design" element={<DesignProjects />} />
          <Route path="/animation" element={<Animation />} />
          <Route path="/interactive" element={<InteractivePage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
